import { Fragment } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router'
import Leaderboard from '../../components/Leaderboard';
import Authorized from '@/components/Authorized';
import CompetitionSponsors from '@/components/Competition/CompetitionSponsors';

export const Route = createFileRoute('/leaderboard/$competitionId')({
  component: LeaderboardPage
})

const logRoute = (id: string) => {
  console.log("Leaderboard route: ", id);
}

function LeaderboardPage() {
  const { competitionId } = useParams({ from: '/leaderboard/$competitionId' });

  logRoute(competitionId)
  return( 
    <Fragment>
      <Authorized>
        <div className="scrolling-container">
          <div className="outer-container">
            <Leaderboard competitionId={competitionId} />
            <CompetitionSponsors competitionId={competitionId} />
          </div>
        </div>
      </Authorized>
    </Fragment>
  ) 
}